import academicDetailsJson from '../../../assets/translations/academic-details.json'

export const academicDetailsContent: any = academicDetailsJson
